import styled from 'styled-components';
import Typography from '~components/dumbs/Typography';
import { LabelProps } from './types';

export const Radio = styled.input`
  accent-color: ${({ theme }) => theme.color.icon.brand.default};
  cursor: pointer;
`;

export const Wrapper = styled.div`
  input[type='radio']:checked + label {
    color: ${({ theme }) => theme.color.text.neutral.strong};
  }
  padding-bottom: ${({ theme }) => theme.spacing.km3};
  padding-top: ${({ theme }) => theme.spacing.km3};
  display: flex;
  align-items: center;
`;

export const Label = styled(Typography).attrs({ as: 'label' })<LabelProps>`
  color: ${({ theme }) => theme.color.text.neutral.default};
  font-size: ${({ theme }) => theme.font.size.m3};
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  font-weight: ${({ theme }) => theme.font.weight.regular};
  margin-left: ${({ theme }) => theme.spacing.km3};
  user-select: none;
  white-space: nowrap;
  cursor: pointer;
`;
